import Tree from './tree';

export default Tree;
